import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// 🔐 Función para obtener el token CSRF desde las cookies
function getCSRFToken() {
  const match = document.cookie.match(/csrftoken=([\w-]+)/);
  return match ? match[1] : '';
}

const Register = ({ onRegisterSuccess }) => {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      // 1. Obtener el token CSRF
      await axios.get('/api/csrf/', {
        withCredentials: true,
      });

      const csrfToken = getCSRFToken();

      // 2. Enviar los datos con el token CSRF en headers
      await axios.post(
        '/api/register/',
        { username, password },
        {
          withCredentials: true,
          headers: {
            'X-CSRFToken': csrfToken,
          },
        }
      );

      setSuccess('Usuario creado exitosamente. Ahora puedes iniciar sesión.');
      setUsername('');
      setPassword('');
    } catch (err) {
      const msg = err.response?.data?.error || 'Error al crear usuario';
      setError(msg);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleRegister}
        className="bg-white p-8 rounded-md shadow-md w-full max-w-sm"
      >
        <h2 className="text-xl font-bold mb-6 text-center text-gray-700">
          Crear nueva cuenta
        </h2>

        {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
        {success && <div className="text-green-600 text-sm mb-4">{success}</div>}

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Usuario</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full border px-3 py-2 rounded-md"
            required
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700">Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border px-3 py-2 rounded-md"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700"
        >
          Crear cuenta
        </button>

        <p className="text-center text-sm mt-4">
          ¿Ya tienes cuenta?{' '}
          <button
            type="button"
            className="text-blue-600 underline"
            onClick={() => {
              if (onRegisterSuccess) {
                onRegisterSuccess(); // vuelve al login
              } else {
                navigate('/login'); // fallback
              }
            }}
          >
            Inicia sesión
          </button>
        </p>
      </form>
    </div>
  );
};

export default Register;
